import AdvertiseWithUs from "../pages/AdvertiseWithUs";

const seoData = {
	home: {
		title: "Travel Rethink Ways | Travel Insights, Deals & Tourism Jobs",
		description:
			"Discover curated escapes, destination stories, travel deals, tourism careers, tour packages, travel guides, and global experiences with Travel Rethink Ways.",
		canonical: "https://travel.rethinkways.com/",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Discover Smarter Ways To Explore The World",
	},

	superDeals: {
		title: "Best Travel Deals & Holiday Packages | Travel Rethink Ways",
		description:
			"Explore travel deals, hotel offers, holiday packages, affiliate stays, destination escapes, luxury getaways, and exclusive travel experiences worldwide.",
		canonical: "https://travel.rethinkways.com/super-deals",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Discover Exclusive Travel Deals & Holiday Escapes",
		tags: {
			All: {
				title: "Best Travel Deals & Holiday Packages | Travel Rethink Ways",
				description:
					"Explore travel deals, hotel offers, holiday packages, affiliate stays, destination escapes, luxury getaways, and exclusive travel experiences worldwide.",
				canonical: "https://travel.rethinkways.com/super-deals",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover Exclusive Travel Deals & Holiday Escapes",
			},
			Attractions: {
				title: "Attractions, Tours & Experiences | Travel Rethink Ways",
				description:
					"Discover attraction tickets, guided tours, theme parks, sightseeing activities, destination experiences, and exclusive travel deals across the world.",
				canonical: "https://travel.rethinkways.com/super-deals?cat=Attractions",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover Top Attraction Deals & Travel Experiences",
			},
			Flights: {
				title: "Flight Ticket Deals & Discounts | Travel Rethink Ways",
				description:
					"Discover flight deals, airfare discounts, airline offers, international routes, budget travel savings, vacation bookings, and global travel escapes worldwide.",
				canonical: "https://travel.rethinkways.com/super-deals?cat=Flights",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover Flight Deals & Smart Airfare Offers",
			},
			Hotels: {
				title: "Hotel Offers, Resort & Unique Stays | Travel Rethink Ways",
				description:
					"Explore hotel offers, luxury resorts, boutique stays, beachfront escapes, family accommodations, and exclusive stay deals worldwide with Travel Rethink Ways.",
				canonical: "https://travel.rethinkways.com/super-deals?cat=Hotels",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover Hotel Deals, Resorts & Unique Stays",
			},
			"Indian Escapes Deals": {
				title: "India Getaway Deals & Holidays | Travel Rethink Ways",
				description:
					"Discover India getaway deals, weekend escapes, luxury stays, destination experiences, holiday offers, cultural journeys, and curated adventures across India.",
				canonical: "https://travel.rethinkways.com/super-deals?cat=Indian%20Escapes%20Deals",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Explore India Getaway Deals & Travel Escapes",
			},
			"International Getaway Deals": {
				title: "International Holidays, Escape & Deals | Travel Rethink Ways",
				description:
					"Explore international getaway, luxury escapes, holiday packages, global destinations, curated adventures, travel experiences, and cultural journeys worldwide.",
				canonical: "https://travel.rethinkways.com/super-deals?cat=International%20Getaway%20Deals",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover International Getaway Deals Worldwide",
			},
		},
	},

	tourPackages: {
		title: "Tour Packages, Holidays & Escapes | Travel Rethink Ways",
		description:
			"Explore India and international tour packages, holiday escapes, curated adventures, luxury stays, cultural journeys, and travel experiences worldwide.",
		canonical: "https://travel.rethinkways.com/tour-packages",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Discover Tour Packages & Holiday Escapes Worldwide",
		tags: {
			All: {
				title: "Tour Packages, Holidays & Escapes | Travel Rethink Ways",
				description:
					"Explore India and international tour packages, holiday escapes, curated adventures, luxury stays, cultural journeys, and travel experiences worldwide.",
				canonical: "https://travel.rethinkways.com/tour-packages",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover Tour Packages & Holiday Escapes Worldwide",
			},
			india: {
				title: "India Tour Packages & Holiday Escapes | Travel Rethink Ways",
				description:
					"Explore India tour packages, weekend escapes, curated holidays, honeymoon trips, cultural journeys, and destination experiences with Travel Rethink Ways.",
				canonical: "https://travel.rethinkways.com/tour-packages?section=india",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover India Tour Packages & Travel Escapes",
			},
			international: {
				title: "International Getaways & Tour Deals | Travel Rethink Ways",
				description:
					"Explore international getaway deals, holiday escapes, luxury stays, global destinations, cultural journeys, and curated travel experiences worldwide.",
				canonical: "https://travel.rethinkways.com/tour-packages?section=international",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover International Getaways & Travel Experiences",
			},
			europe: {
				title: "Europe Tour Packages & Holidays | Travel Rethink Ways",
				description:
					"Explore Europe tour packages, luxury holidays, iconic destinations, cultural journeys, scenic escapes, and curated travel experiences across Europe.",
				canonical: "https://travel.rethinkways.com/tour-packages?section=europe",
				image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
				h1: "Discover Europe Tour Packages & Holiday Escapes",
			},
		},
	},

	wishlist: {
		title: "Your Travel Wishlist | Save Trips, Destinations & Deals",
		description:
			"Save your favorite travel destinations, tour packages & deals in your wishlist. Plan and organize your dream trips easily.",
		canonical: "https://travel.rethinkways.com/wishlist",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Your Travel Wishlist",
	},

	about: {
		title: "About Travel Rethink Ways | Smart Travel Experiences",
		description:
			"Travel Rethink Ways is a modern travel platform sharing travel insights, destination experiences, curated escapes, travel deals, and smarter ways to explore.",
		canonical: "https://travel.rethinkways.com/about-us",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Redefining Exploration Through Smarter Travel Experiences",
	},

	contact: {
			title: "Contact Travel Rethink Ways | Travel Support & Partnerships",
			description:
				"Contact Travel Rethink Ways for travel support, partnerships, tourism inquiries, travel collaborations, and destination experiences worldwide.",
			canonical: "https://travel.rethinkways.com/contact-us",
			image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
			h1: "Connect With Travel Rethink Ways",
		},
	latestUpdates: {
		title: "Latest Updates | Travel Rethink Ways",
		description:
			"Browse the latest travel blogs, fresh destination stories, and new editorial updates from Travel Rethink Ways.",
		canonical: "https://travel.rethinkways.com/latest-updates",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Latest Travel Updates",
	},
	jobs: {
		title: "Travel & Hospitality Jobs | Careers & Tourism Roles",
		description:
			"Explore curated travel and hospitality jobs across hotels, airlines, tour operators, OTAs, and destination brands. Filter by company and job type to find your next role.",
		canonical: "https://travel.rethinkways.com/jobs",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Travel & Hospitality Jobs",
	},
		affiliate: {
		title: "Travel Affiliate Program | Partner with Travel Rethink Ways",
		description:
			"Join Travel Rethink Ways affiliate program, collaborate to promote destinations, stays, and experiences, and reach a global audience effectively.",
		canonical: "https://travel.rethinkways.com/affiliate-disclosure",
		image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
		h1: "Partner With Travel Rethink Ways Affiliate Program",
	},

disclaimer: {
	title: "Disclaimer | Travel Rethink Ways",
	description:
		"Learn about Travel Rethink Ways disclaimer, including content accuracy, affiliate partnerships, and third-party links across the website.",
	canonical: "https://travel.rethinkways.com/disclaimer",
	image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
	h1: "Travel Rethink Ways Disclaimer & Transparency",
},

privacyPolicy: {
	title: "Privacy Policy | Trusted Travel Rethink Ways",
	description:
		"Read Travel Rethink Ways Privacy Policy to understand how we protect your data, respect your rights, and deliver secure, personalized travel experiences.",
	canonical: "https://travel.rethinkways.com/privacy-policy",
	image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
	h1: "Your Privacy Matters At Travel Rethink Ways",
},

cookiesPolicy: {
	title: "Cookies Policy | Travel Rethink Ways",
	description:
		"Learn how Travel Rethink Ways uses cookies and similar technologies to improve site performance, personalize experiences, and support relevant promotions.",
	canonical: "https://travel.rethinkways.com/cookies-policy",
	image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
	h1: "Cookies & Tracking Technologies",
},

termsConditions: {
	title: "Terms & Conditions | Responsible Travel Rethink Ways",
	description:
		"Review the Terms & Conditions of Travel Rethink Ways for policies, user rights, responsibilities, and content usage guidelines.",
	canonical: "https://travel.rethinkways.com/terms-and-conditions",
	image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
	h1: "Terms & Conditions For Using Travel Rethink Ways",
},
advertise: {
	title: "Advertise, Promote & Partner | Travel Rethink Ways",
	description:
		"Advertise with Travel Rethink Ways to promote destinations, travel brands, hotels, tourism experiences, curated campaigns, and global travel visibility.",
	canonical: "https://travel.rethinkways.com/advertise-with-us/",
	image: "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg",
	h1: "Partner With Travel Rethink Ways",
}
};

export default seoData;
